import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="phone, iphone, mobile"><path fillRule="evenodd" clipRule="evenodd" d="M5 2.75C5 1.7835 5.7835 1 6.75 1H17.25C18.2165 1 19 1.7835 19 2.75V21.25C19 22.2165 18.2165 23 17.25 23H6.75C5.7835 23 5 22.2165 5 21.25V2.75ZM9.75 18.5C9.33579 18.5 9 18.8358 9 19.25C9 19.6642 9.33579 20 9.75 20H14.25C14.6642 20 15 19.6642 15 19.25C15 18.8358 14.6642 18.5 14.25 18.5H9.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPhone;
